import React, { Component, PropTypes } from 'react';
import {findDOMNode} from 'react-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../redux/signInPopupActions';
import styles from 'src/styles/AuthPopup.scss';
import config from 'src/config';
import * as texts from 'src/texts';
import TelephoneInput from 'react-telephone-input';
import {extractNumbers} from 'src/logic/utils';
import PopoverTrigger from 'src/components/popover/PopoverTrigger';
import {isValidNumber} from 'src/logic/utils';
import debounce from 'lodash/debounce';
import cx from 'classnames';
const phoneInputImgs = require('src/imgs/flags.png');
import fm from 'src/logic/formatMessage';

export class SignInPopupPasswordResetForm extends Component {
  state = {
    isPhoneValid: true
  };

  onSubmit = (e) => {
    e.preventDefault();
    if (!this.state.isPhoneValid) {
      return false;
    }
    this.props.actions.resetPassword('+' + extractNumbers(findDOMNode(this.refs.loginInput).children[0].value));
  };

  onPhoneChange = debounce((e) => {
    if (e.length < config.minLengthForNumberVerifying) {
      this.setState({ isPhoneValid: true });
      this.props.actions.resetErrors();
      return false;
    }
    this.setState({
      isPhoneValid: isValidNumber(e)
    });
  }, 200);

  render() {
    const {actions, resetPasswordErr} = this.props;
    const phoneNumberTooltipType = (!this.state.isPhoneValid && resetPasswordErr) && 'error';
    let phoneNumberTooltipText = this.state.isPhoneValid ? texts.enterNumberPrompt : texts.incorrectNumberErrText;
    if (resetPasswordErr) {
      phoneNumberTooltipText = resetPasswordErr;
    }
    const phoneNumberInputContainerClassName = {
      [styles.telephoneInputContainer]: true,
      'w-100': true,
      [styles.invalidInput]: !this.state.isPhoneValid || !!resetPasswordErr
    };

    return (
      <form onSubmit={this.onSubmit}>
        <div className="m-t-1_5">
          <PopoverTrigger
            type={phoneNumberTooltipType}
            content={fm(phoneNumberTooltipText)}
            placement="left">
            <TelephoneInput
              ref="loginInput"
              classNames={cx(phoneNumberInputContainerClassName)}
              defaultCountry='ru'
              preferredCountries={config.phoneInputCodeSelectorPreferredCountries}
              initialValue={this.props.value || undefined}
              flagsImagePath={phoneInputImgs}
              onChange={this.onPhoneChange} />
          </PopoverTrigger>
        </div>
        <button
          className={styles.sendBtn}
          type="submit">
          Восстановить пароль
        </button>
        <button
          onClick={this.props.actions.cancelPasswordResetting}
          className={styles.changeNumberPrompt}>Войти</button>
      </form>
    );
  }
}



SignInPopupPasswordResetForm.propTypes = {
  actions: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    ...state.signInPopupReducer
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignInPopupPasswordResetForm);



/** WEBPACK FOOTER **
 ** ./src/components/SignInPopup/elements/SignInPopupPasswordResetForm.jsx
 **/